<template>
  <component :is="screenWidth < 375 ? 'Xs400Gray' : 'Sm400Gray'">
    <slot />
  </component>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import Sm400Gray from '~/components/typography/Sm400Gray.vue'
import Xs400Gray from '~/components/typography/Xs400Gray.vue'

import resizeMixin from '~/mixins/resize'

export default defineComponent({
  components: {
    Sm400Gray,
    Xs400Gray,
  },
  mixins: [resizeMixin],
})
</script>
